import React from 'react';
import PropTypes from 'prop-types';

const WebinarBlock = props => {
  return (
    <div className="webinar-block">
      <div className="webinar-header">
        <div className="is-flex align-items-center">
          <img src="img/icons/webinar.svg" />
          <span className="webinar-header-title ml-5px">Nearest webinar</span>
        </div>

        <p className="webinar-header-date">{props.webinar.date}</p>
        {/* November 27, 2019 at 19:00 */}
      </div>
      <div className="webinar-content">
        <p className="webinar-content-title">{props.webinar.name}</p>
        <p className="webinar-content-text">{props.webinar.description}</p>
        <p className="webinar-content-price">{props.webinar.price === 0 ? '---' : props.webinar.price} €</p>
        <button className="gradient-button mt-10px">Participate</button>
      </div>
    </div>
  );
};

WebinarBlock.propTypes = {
  webinar: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
  }).isRequired,
};

export default WebinarBlock;
